module.exports = __webpack_public_path__ + "img/logo-en-white.da2ab523.svg";